/* eslint-disable no-console */
import { logInfo, logWarning } from 'src/shared/telemetry/logger';

/**
 * Log a warning to the console in development and a warning to Sentry in
 * deployed environments
 *
 * @param message
 */
export const warn = (message: string) => {
  if (__DEV__) {
    console.warn(message);
  } else {
    logWarning(message);
  }
};

/**
 * Log an info message to the console in development and a warning to Sentry in
 * deployed environments
 *
 * @param message
 */
export const info = (message: string) => {
  if (__DEV__) {
    console.info(message);
  } else {
    logInfo(message);
  }
};
